import baseUrl from './baseUrl';

const URL_GET_USER_BY_EMAIL = `${baseUrl}/user`;

const getUserByEmail = async email => {
  try {
    const data = await fetch(URL_GET_USER_BY_EMAIL, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ email })
    });

    if (!data.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }

    const response = await data.json();

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default getUserByEmail;
